import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigurationKey = 'iframeEmbed';

interface IframeEmbedDataProps {
  html: string;
  height: string;
  dataId?: string;
}

export interface IframeEmbedThemeProps {
  backgroundColor: string;
}

export type IframeEmbedProps = IframeEmbedDataProps & MandatoryAdditionalStyle;

const createIframeEmbedWrapperStyle = (backgroundColor: string, height: string) => StyleSheet.create({
  style: {
    backgroundColor,
    paddingTop: `${height}px`,
    position: 'relative',
  },
});

const createIframeEmbedStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

const parseIframeHtml = (html: string) => {
  const iframeStyle = createIframeEmbedStyle();
  return html
    .replace(/<iframe/, `<iframe class="${css(iframeStyle.style)}"`);
};

export const IframeEmbed: React.FunctionComponent<IframeEmbedProps> = props => {
  const { html, dataId, height, additionalStyle } = props;
  const { backgroundColor } = useTheme<IframeEmbedThemeProps>(componentConfigurationKey);
  const iframeWrapperStyle = createIframeEmbedWrapperStyle(backgroundColor, height);
  return (
    <ErrorBoundary>
      {/* eslint-disable-next-line react/no-danger */}
      <figure data-id={dataId} className={css(iframeWrapperStyle.style, additionalStyle.style)} dangerouslySetInnerHTML={{ __html: parseIframeHtml(html) }} />
    </ErrorBoundary>
  );
};
